import React, { Component } from 'react'
import { string, bool } from 'prop-types'

import $ from 'jquery'
import API from 'utils/API'

import { Container, Row } from 'components/qstrap'

import ThumbnailSlider from 'components/molecules/ThumbnailSlider'
import ArticleItem from 'components/molecules/ArticleItem'
import ArticleSkeleton from 'components/skeletons/ArticleSkeleton'
import ActionTypeProp from 'utils/prop_types/ActionTypeProp'

class Articles extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoading: true,
      isError: false,
      articles: [],
    }
  }

  componentDidMount() {
    // Use jquery ajax because axios doesn't support jsonp
    const dataOpts = {
      _embed: true,
      per_page: 5,
      callback: '?',
    }

    $.ajax({
      url: this.props.sourceUrl,
      data: Object.assign(dataOpts, !this.props.global && { categories: 679384864 }),
      success: (response) => {
        this.setState({
          isLoading: false,
          isError: false,
          articles: response,
        })
      },
      error: () => {
        this.setState({
          isLoading: false,
          isError: true,
        })
      },
    })
  }

  render() {
    const { isLoading, isError, articles } = this.state
    const { sectionTitle, className, withSeeMore, type } = this.props

    return (
      <div className={`quipper-articles ${className}`}>
        <Container>
          <h4 className="quipper-articles__title">
            {
              withSeeMore &&
                <a className="btn pull-right" href="https://www.quipper.com/id/blog/category/quipper-campus/" target="_blank" rel="noopener noreferrer">
                  <small>Selengkapnya</small>
                </a>
            }
            { sectionTitle }
          </h4>
        </Container>
        <Container>
          <Row>
            <ThumbnailSlider>
              {isLoading || isError ? (
                [...Array(3)].map((val, i) => <ArticleSkeleton key={i} />)
              ) :
                articles.map((article, i) =>
                  <ArticleItem dataTestId={`rec-article-card-${i}`} key={article.id} {...article} type={type} />)
              }
            </ThumbnailSlider>
          </Row>
        </Container>
        <style jsx>
          {`
            .quipper-articles {
              padding-top: 80px;
              padding-bottom: 80px;
              @media(max-width: 991px) {
                padding-top: 40px;
                padding-bottom: 40px;
              }
              &__title {
                color: #0c2846;
                font-weight: bold;
                margin: 0 0 24px;
                @media screen and (min-width: 768px) {
                  font-size: 24px;
                }
              }

              h4 {
                a {
                  margin-top: -5px;

                  small {
                    font-size: 14px;
                    font-weight: bolder;
                  }
                }
              }
              :global(.ThumbnailSlider) {
                overflow: unset;
              }
              :global(.slick-slider) {
                overflow: hidden;
              }
              :global(.slick-arrow) {
                top: 160px;
              }
            }
          `}
        </style>
      </div>
    )
  }
}

Articles.propTypes = {
  sourceUrl: string,
  sectionTitle: string,
  global: bool,
  withSeeMore: bool,
  type: ActionTypeProp,
}

Articles.defaultProps = {
  sourceUrl: API.endPoints().articles,
  withSeeMore: true,
}

export default Articles
